import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useTranslation } from '@stepstone-platform/i18n';
import { updateEmail, emailSelector, updateEmailError, updateEmailErrorMessage, } from '../appleUpdateEmailSlice.js';
import { Input } from '../../../components/common/Input/index.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { validateEmail } from '../../../helpers/validateEmail.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
export const AppleUpdateEmailInput = () => {
    const { t } = useTranslation();
    const emailState = useAppSelector(emailSelector);
    const dispatch = useAppDispatch();
    const { trackFieldError } = useTrack('twoStep');
    const onBlurEmail = ({ target: { value }, }) => {
        const emailString = value;
        const hasError = !validateEmail(emailString);
        dispatch(updateEmailError(hasError));
        if (hasError) {
            dispatch(
            // TODO: adjust labels
            updateEmailErrorMessage(t('loginregistration.email.validation.error')));
            trackFieldError({
                formFieldErrors: 'emailAddressNotValid',
                genericComponentState: 'postAppleLoginAddYourEmailForm',
            });
        }
    };
    const emailOnChange = ({ target: { value }, }) => {
        dispatch(updateEmail(value));
    };
    const { value, error, errorMessage } = emailState;
    const formLabel = t('loginregistration.twoStepLoginRegistration.appleUpdateEmail.email.headerInput');
    const placeholderLabel = t('loginregistration.twoStepLoginRegistration.appleUpdateEmail.email.placeholder');
    return (_jsx(Input, { dataTestId: "apple-update-email-input", value: value, onChange: emailOnChange, type: 'email', name: 'email', formLabel: formLabel, placeholder: placeholderLabel, hasError: error, errorText: errorMessage, onBlur: onBlurEmail, autoComplete: 'username' }));
};
//# sourceMappingURL=AppleUpdateEmailInput.js.map